var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carrousel"},[_c('button',{class:[{ active: _vm.interval }, 'item'],on:{"blur":function($event){return _vm.stopCarrousel()},"click":function($event){return _vm.toggleCarrousel()}}},[_vm._l((_vm.frames),function(frameIndex){return [_c('v-image',{key:frameIndex,attrs:{"config":{
          image: _vm.items[frameIndex - 1].config,
          x: _vm.item.position.x,
          y: _vm.item.position.y,
          opacity: _vm.currentFrame + 1 === frameIndex ? 1 : 0,
        }}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }